import { SCORM_FORMAT_TYPES } from "@/constants/scormFormat";

/**
 * Get file name and replace space with _
 * For single SCO, appends "single-sco" to the file name.
 * @param {*} title
 * @param {*} resolution
 * @param {string} [format] - SCORM format: multi-sco | single-sco
 * @returns
 */
export const getSCORMFileName = (title, resolution, format) => {
  const base = `${title.replaceAll(/\s+/g, "_")}_${resolution}`;
  return format === SCORM_FORMAT_TYPES.SINGLE_SCO ? `${base}_single-sco` : base;
};
